import React from "react";
import { useSelector } from "react-redux";
import TestModal from "../../../features/sandbox/TestModal";
import LoginForm from "../../../features/auth/LoginForm";
import RegisterForm from "../../../features/auth/RegisterForm";

import CardFormModal from "../../../features/card/CardFormModal";
import SectionFormModal from "../../../features/section/SectionFormModal";
import CardModal from "../../../features/card/CardModal";
import CommitFileFormModal from "../../../features/commit/CommitFileFormModal";

import CommentModal from "../../../features/comment/CommentModal";
import SpaceModal from "../../../features/space/SpaceModal";
import UserFormModal from "../../../features/user/UserFormModal";
import UserConfirmModal from "../../../features/user/UserConfirmModal";
import ProfileFormModal from "../../../features/profiles/ProfileFormModal";

import WorkspaceFormModal from "../../../features/workspace/WorkspaceFormModal";

import SupplierFormModal from "../../../features/library/supplier/SupplierFormModal";
import ProductFormModal from "../../../features/library/product/ProductFormModal";
import Selection3dFormModal from "../../../features/design/selection3d/Selection3dFormModal";
import ProductSelectorFormModal from "../../../features/library/product/ProductSelectorFormModal";
import GeometryBasicViewerModal from "../../../features/geometry/GeometryBasicViewerModal";

export default function ModalManager() {
  const modalLookup = {
    TestModal,
    CardModal,
    CardFormModal,
    SupplierFormModal,
    ProductFormModal,
    Selection3dFormModal,
    ProductSelectorFormModal,
    SectionFormModal,
    CommitFileFormModal,
    CommentModal,
    SpaceModal,
    UserFormModal,
    UserConfirmModal,
    ProfileFormModal,
    WorkspaceFormModal,
    GeometryBasicViewerModal,
    LoginForm,
    RegisterForm,
  };
  const currentModal = useSelector((state) => state.modals);
  let renderedModal;

  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modalLookup[modalType];
    renderedModal = <ModalComponent {...modalProps} />;
  }

  return <span>{renderedModal}</span>;
}
